import { Component } from "react"

/* Components */
import { InnerLayout } from "../../components"

/* Widgets */
import RoundView from "./RoundView"
import VipRound from "../VipGame/GameInformation"
import ElectronRound from "../ElectronGame/GameInformation"

/* Registry */
import { find } from "./registry"

/* Constants */
import { findByRoute } from "../../constants/electron"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { round as resolve } from "../../api/Game"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Icons */
import { CloseIcon, TagIcon } from "../../components/Icons"


/* THE VIP GAMES — ONE PLAYER PER ROUND, AND THE PANEL DRAWS THEM ITS OWN WAY */
const VIP = {
    "russian-vip-poker": "RVP",
    "queen-vip-poker": "QVP",
    "european-vip-poker": "EVP",
}


/*
    Widget RoundModal — ONE ROUND OF ANY GAME, OPENED FROM ANYWHERE

    open({ round, table }) is all it takes: the table is named by its uid, its slug or its id, and the
    round by its id, its round id or the number an operator reads out. The server answers which game
    the table plays, and the card of that very game is drawn inside.

        this._round.open({ round: "31150", table: "table-russian-multipoker" })
        this._round.open({ round: 575, table: uid })
*/
class RoundModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",

            table: null,
            catalog: null,
            game: null,
        }
    }

    /* Open Action */
    open = ({ round, table }) => {

        /* Check Parameters */
        if (!round || !table) {
            return
        }

        this.setState({ visible: true, status: "loading", table: null, catalog: null, game: null }, () => this.load(round, table))
    }

    /* Close Action */
    close = () => {

        /* Fields */
        const { close } = this.props

        this.setState({ visible: false })

        /* The list behind the modal may have to read itself again */
        if (close) {
            close()
        }
    }

    /* Load Action */
    load = (round, table) => {

        /* Send to REST API */
        resolve({ round, table }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", table: response.data.table, catalog: response.data.catalog, game: response.data.game })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission" })
            }
            else if (response.status === 404) {
                this.setState({ status: "empty" })
            }
            else if (response.status === 498) {
                this.setState({ status: "key" })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => {
            this.setState({ status: "network" })
        })
    }

    /* Draw The Round Of The Game The Table Plays */
    _content = () => {

        /* Fields */
        const { socket } = this.props
        const { status, table, catalog, game } = this.state

        /* Layout */
        if (status !== "ok" || !table || !catalog || !game) {
            return <InnerLayout status={status === "ok" ? "error" : status} />
        }

        /* A Live Game Of The Registry */
        const config = find(catalog.key)

        if (config) {
            return (
                <RoundView
                    api={config.api}
                    config={config}
                    uid={table.uid}
                    gameID={game.id}
                    postfix={config.postfix}
                    socket={socket}
                />
            )
        }

        /* A Vip Game — one player sits at the round, so it carries no player list */
        if (VIP[catalog.key]) {
            return <VipRound uid={table.uid} gameID={game.id} postfix={VIP[catalog.key]} socket={socket} />
        }

        /* An Electron Game — its rows of cards come from the registry of the constants */
        const electron = findByRoute(catalog.key)

        if (electron) {
            return <ElectronRound game={electron} uid={table.uid} gameID={game.id} socket={socket} />
        }

        /* The Catalogue Knows The Game, The Panel Does Not */
        return <InnerLayout status="empty" />
    }

    render = () => {

        /* Fields */
        const { visible, game, table } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="rnd--modal round"
                overlayClassName="rnd--overlay"
                closeTimeoutMS={200}
            >

                <div className="rnd--modal-header">

                    <div className="rnd--modal-icon blue"><TagIcon size={18} /></div>

                    <div className="rnd--modal-text">
                        <h2>{t("game.gameNumber")}{game ? game.number : ""}</h2>
                        <p>{table ? table.name : t("round.loading")}</p>
                    </div>

                    <div onClick={() => this.close()} className="rnd--modal-close"><CloseIcon size={16} /></div>

                </div>

                <div className="rnd--modal-body">
                    {this._content()}
                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(RoundModal)
